import { Stack } from '@mui/material';

import { BlockValueTemplateField } from '../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockSelectField } from '../../ConfigFields/SelectField';

const evaluationTypeOptions = [
  { label: 'Accuracy', value: 'ACCURACY' },
  { label: 'Semantic similarity', value: 'SEMANTIC_SIMILARITY' },
  { label: 'Faithfulness', value: 'FAITHFULNESS' },
];

export function EvaluationFormFields() {
  return (
    <Stack spacing={2}>
      <BlockValueTemplateField fieldName="config.output" label="Compare this generated value:" />
      <BlockValueTemplateField fieldName="config.reference" label="To this source value:" />
      <BlockSelectField
        fieldName="config.evaluationType"
        label="Using this method:"
        options={evaluationTypeOptions}
      />
    </Stack>
  );
}
